const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the site selector component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('siteSelector', ['Categories', '$q', function (Categories, $q) {
  return {
    restrict: 'E',
    scope: {
      site: '=',
      information: '='
    },
    template: require('../../../templates/directives/cms/site-selector.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.locations = {};
      self.queries = [];
      self.queryIds = {};

      self.parseOptions = function() {
        self.queries = [];
        if (!$scope.site) {
          return;
        }
        var item = self.locations[$scope.site];
        if (item) {
          self.queryIds = {};
          self.queryIds[item._id] = true;
          self.queries.push(self.locations[item._id]);
        }
      };

      self.removeAllTags = function() {
        self.queries.splice(0);
        self.itemAddedRemoved();
      };

      // ------------- start ngTag triggered actions ------------
      self.itemAddedRemoved = function($tag) {
        $scope.site = null;
        self.queryIds = {};
        for (var i = 0; i < self.queries.length; i++) {
          $scope.site = self.queries[i]._id;
          self.queryIds[self.queries[i]._id] = true;
        }
      };

      self.itemAdding = function($tag) {
        for (var i = 0; i < self.queries.length; i++) {
          if (self.queries[i] && $tag && self.queries[i]._id !== $tag._id) {
            self.queries.splice(i, 1);
            return;
          }
        }
      };

      self.getOptions = function(input) {
        var deferred = $q.defer();
        setTimeout(function() {
          var items = [];
          input = input ? input.toLowerCase() : '';
          var locationsPlaceholder = {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true};
          var addedItems = {
            locations: false
          };

          // Add locations to options
          for (var loc in self.locations) {
            if (new RegExp(input).test(self.locations[loc].name.toLowerCase()) && !self.queryIds[self.locations[loc]._id]) {
              if (!addedItems.locations) {
                items.push(locationsPlaceholder);
                addedItems.locations = true;
              }
              items.push(self.locations[loc]);
            }
          }

          deferred.resolve(items);

        }, 50);

        return deferred.promise;
      };

      // ------------- End ngTag triggered actions ------------
      var legacyName = function(item) {
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.text = item.name;

        if (item.parent) {
          parent = self.locations[item.parent];
          parentName = parent.name + ' -> ';
          papa = parent.parent;
          item.text = parentName + item.name;
        }

        if (papa) {
          papa = self.locations[papa];
          papaName = papa.name + ' -> ';
          item.text = papaName + parentName + item.name;
        }
      };

      self.sortLocations = function(data) {
        self.locations = {};
        angular.forEach(data, function(cat) {
          self.locations[cat._id] = {
            name: cat.name,
            children: cat.children,
            parent: cat.parent,
            _id: cat._id,
            type: 'location'
          };
        });

        for (var loc in self.locations) {
          legacyName(self.locations[loc]);
        }
      };

      self.initialize = function() {
        Categories.find({
          fields: ['_id', 'company', 'name', 'location', 'timezone', 'parent', 'children'].join(','),
          location: true,
          sort: 'name,1'
        }).$promise
        .then(function(data) {
          self.sortLocations(data);
          if ($scope.site) {
            self.parseOptions();
            return;
          }
        });
      };

      // Initialize
      self.initialize();

      var siteWatch = $scope.$watch('selector.site', function(newVal, oldVal) {
        if (!newVal) {
          self.parseOptions();
          siteWatch();
        }
      });

    }],
    controllerAs: 'selector'
  };
}]);
